// extracted by mini-css-extract-plugin
export default {"user_menu_container":"index_user_menu_container__PMAcT","user_menu_avatar":"index_user_menu_avatar__y+0qG"};